<template>
  <div class="bg-primary-50 py-40 paragraph--padded">
    <div class="container">
      <h2
        v-if="title"
        v-blokkli-editable:field_title
        class="font-bold text-xl mb-15 text-balance"
      >
        {{ title }}
      </h2>
      <div
        v-if="description"
        v-blokkli-editable:field_description
        class="mb-25"
        v-html="description"
      />
      <CleverReachForm
        v-if="
          cleverReachForm?.elements &&
          cleverReachForm.action &&
          cleverReachForm.method
        "
        :elements="cleverReachForm.elements"
        :action="cleverReachForm.action"
        :method="cleverReachForm.method"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphCleverReachFormFragment } from '#graphql-operations'

defineBlokkli({
  globalOptions: ['bkVisibleLanguages'],
  bundle: 'cleverreach_form',
  chunkName: 'rare',
})

defineProps<{
  title?: string
  description?: string
  cleverReachForm?: ParagraphCleverReachFormFragment['cleverReachForm']
}>()

defineOptions({
  name: 'ParagraphCleverReachForm',
})
</script>
